import * as React from 'react';

import './Breadcrumbs.scss';

export interface IBreadcrumbsProps {
  children?: any;
  hideOnMobile?: boolean;
}

export default function Breadcrumbs(props: IBreadcrumbsProps) {
  const setClassName = () => {
    let className = 'rp-breadcrumbs';
    if (props.hideOnMobile) {
      className += ' rp-breadcrumbs--hide-mobile';
    }
    return className;
  };
  return (
    <div className={setClassName()}>
      <span>{props.children}</span>
    </div>
  );
}
